import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import InfoCard from '../InfoCard';

import Description from './Description';

import { composeUser } from '../../utils/plan';

const propTypes = {
  id: PropTypes.number.isRequired,
  companyName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
};

const Dealer = ({ id, ...dealer }) => (
  <InfoCard
    title={`Dealer #${id}`}
    description={<Description {...dealer} />}
    data={dealer}
    fields={[
      {
        id: 'companyName',
        title: 'Company',
      },
      {
        id: 'email',
        title: 'Email',
      },
      {
        id: 'address',
        title: 'Address',
      },
      {
        id: 'phone',
        title: 'Phone',
      },
    ]}
  />
);

Dealer.propTypes = propTypes;

const mapStateToProps = ({ admin: { planDealer } }) => composeUser(planDealer);

export default connect(mapStateToProps)(Dealer);
